import { useQuery } from "@tanstack/react-query"

import { DateFilter } from "@/types/filters"

import { supabase } from "../lib/supabase"

export interface KpiMetric {
  name: string
  value: number | null
  target: string | number | null
  description?: string
}

export interface KpiData {
  actualApplications: KpiMetric
  timeToHire: KpiMetric
  trialPassRate: KpiMetric
  orientationAttendanceRate: KpiMetric
  orientationQuizScore: KpiMetric
  vehicleCollection: KpiMetric
  trialReviewsCompletion: KpiMetric
  trialBlocksNoShowRate: KpiMetric
}

interface KpiResponse {
  success: boolean
  data: KpiData
}

/**
 * Hook to fetch KPI metrics data
 * @param dateFilter - Optional date filter
 * @returns Query result with KPI metrics data
 */
export const useKPIsData = (dateFilter?: DateFilter, jobId?: string) => {
  return useQuery({
    queryKey: ["kpis", dateFilter, jobId ?? "all"],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke<KpiResponse>("metrics-kpis", {
        body: { dateFilter, jobId: jobId ?? null },
      })

      if (error) {
        throw new Error(error.message)
      }

      if (!data || !data.success) {
        throw new Error("Failed to fetch KPI metrics data")
      }

      return data.data
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
